<template>
  <el-button type="primary" size="small" @click="openDialog">Выдать абонемент</el-button>
  <el-dialog v-model="dialogVisible" title="Выдать абонемент" width="400px">
    <el-form label-width="120px">
      <el-form-item label="Сертификат">
        <el-select v-model="selectedCertificateId" placeholder="Выберите сертификат">
          <el-option
            v-for="c in certificates"
            :key="c.id"
            :label="c.title + ' (' + c.amount + '₽, ' + c.duration_months + ' мес.)'"
            :value="c.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Сумма">
        <el-input-number v-model="certificateAmount" :min="0" style="width: 100%" :disabled="true"/>
      </el-form-item>
      <el-form-item label="Сумма к оплате">
        <el-input-number v-model="amountPaid" :step="100"  :min="0" style="width: 100%" />
      </el-form-item>
      <el-form-item label="Способ оплаты">
        <el-radio-group v-model="form.payment_type">
          <el-radio label="cash">Наличные</el-radio>
          <el-radio label="cashless">Безналичный</el-radio>
          <el-radio label="mix">Смешанный</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.payment_type === 'mix'">
        <el-form-item label="Наличные">
          <el-input-number
            v-model="amountCash"
            :step="100"
            :min="0"
            :max="amountPaid - (amountCashless || 0)"
            style="width: 100%"
            @change="handleCashChange"
          />
        </el-form-item>
        <el-form-item label="Безналичный">
          <el-input-number
            v-model="amountCashless"
            :step="100"
            :min="0"
            :max="amountPaid - (amountCash || 0)"
            style="width: 100%"
            @change="handleCashlessChange"
          />
        </el-form-item>
      </template>
      <el-form-item label="Комментарий">
        <el-input type="textarea" v-model="form.comment" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">Отмена</el-button>
      <el-button
        type="primary"
        :disabled="!canIssue"
        @click="issueAbonement"
      >Выдать</el-button>
    </template>
  </el-dialog>
  <el-table :data="abonements" size="small" style="width: 100%">
    <el-table-column prop="title" label="Наименование" />
    <el-table-column prop="amount_initial" label="Номинал" width="100"/>
    <el-table-column prop="amount_left" label="Остаток" width="100"/>
    <el-table-column prop="comment" label="Комментарий" />
    <el-table-column
      prop="activated_at"
      label="Дата выдачи"
      width="130"
    >
      <template #default="{ row }">
        {{ formatDate(row.activated_at) }}
      </template>
    </el-table-column>
    <el-table-column
      prop="expires_at"
      label="Окончание"
      width="130"
    >
      <template #default="{ row }">
        {{ formatDate(row.expires_at) }}
      </template>
    </el-table-column>
    <el-table-column label="Действия" width="100">
      <template #default="{ row }">
        <el-button
          v-if="row.amount_left === row.amount_initial"
          size="small"
          type="danger"
          @click="onRemoveAbonement(row)"
        >Удалить</el-button>
        <span v-else style="color: var(--ui-color-text-disabled); font-size: 12px;">Удаление недоступно</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ClientAbonements',
  props: {
    clientId: { type: Number, required: true }
  },
  emits: ['abonement-updated'],
  data() {
    return {
      dialogVisible: false,
      selectedCertificateId: null,
      form: {
        payment_type: 'cash',
        comment: ''
      },
      certificateAmount: null,
      amountPaid: null,
      amountCash: null,
      amountCashless: null,
      autoNumber: ''
    }
  },
  computed: {
    ...mapState('abonements', ['abonements']),
    ...mapState('certificates', ['certificates']),
    canIssue() {
      if (!this.selectedCertificateId) return false
      if (!this.amountPaid || this.amountPaid <= 0) return false
      if (this.form.payment_type === 'mix') {
        if (this.amountCash == null || this.amountCashless == null) return false
        if ((this.amountCash + this.amountCashless) !== this.amountPaid) return false
      }
      return true
    }
  },
  watch: {
    selectedCertificateId(newVal) {
      const cert = this.certificates.find(c => c.id === newVal)
      if (cert) {
        this.certificateAmount = cert.amount
        this.amountPaid = cert.amount
        this.amountCash = null
        this.amountCashless = null
      } else {
        this.certificateAmount = null
        this.amountPaid = null
        this.amountCash = null
        this.amountCashless = null
      }
    },
    'form.payment_type'(val) {
      if (val !== 'mix') {
        this.amountCash = null
        this.amountCashless = null
      }
    },
  },
  methods: {
    ...mapActions('abonements', ['getAbonements', 'addAbonement', 'deleteAbonement']),
    ...mapActions('certificates', ['fetchCertificates']),
    formatDate(ts) {
      if (!ts) return ''
      const date = new Date(ts * 1000)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    },
    openDialog() {
      this.dialogVisible = true;
      this.selectedCertificateId = null;
      this.fetchCertificates();
      this.form = {
        payment_type: 'cash',
        comment: ''
      };
      this.certificateAmount = null
      this.amountPaid = null
      this.amountCash = null
      this.amountCashless = null
    },
    async issueAbonement() {
      // Формируем массив платежей согласно типу оплаты
      let payments = [];
      if (this.form.payment_type === 'cash') {
        payments = [{ method: 'cash', amount: Number(this.amountPaid) }];
      } else if (this.form.payment_type === 'cashless') {
        payments = [{ method: 'cashless', amount: Number(this.amountPaid) }];
      } else if (this.form.payment_type === 'mix') {
        if (this.amountCash) {
          payments.push({ method: 'cash', amount: Number(this.amountCash) });
        }
        if (this.amountCashless) {
          payments.push({ method: 'cashless', amount: Number(this.amountCashless) });
        }
      }

      const payload = {
        client_id: this.clientId,
        certificate_id: this.selectedCertificateId,
        amount_initial: Number(this.certificateAmount),
        amount_left: Number(this.certificateAmount),
        comment: this.form.comment,
        payments
      };

      await this.addAbonement(payload);
      this.$emit('abonement-updated')

      this.dialogVisible = false;
      this.selectedCertificateId = null;
      this.form = {
        payment_type: 'cash',
        comment: ''
      };
      this.certificateAmount = null;
      this.amountPaid = null;
      this.amountCash = null;
      this.amountCashless = null;
    },
    onRemoveAbonement(row) {
      this.$confirm('Вы уверены, что хотите удалить этот абонемент?', 'Подтверждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'warning'
      }).then(() => {
        this.deleteAbonement({ abonement_id: row.id, client_id: row.client_id })
          .then(() => {
            this.$emit('abonement-updated')
          });
      }).catch(() => {});
    },
    handleCashChange() {
      if (this.amountCash > this.amountPaid) {
        this.amountCash = this.amountPaid
      }
      if ((this.amountCash + (this.amountCashless || 0)) > this.amountPaid) {
        this.amountCashless = this.amountPaid - this.amountCash
      }
    },
    handleCashlessChange() {
      if (this.amountCashless > this.amountPaid) {
        this.amountCashless = this.amountPaid
      }
      if (((this.amountCash || 0) + this.amountCashless) > this.amountPaid) {
        this.amountCash = this.amountPaid - this.amountCashless
      }
    },
  },
  mounted() {
    if(this.clientId) {
      this.getAbonements({ client_id: this.clientId })
    }
  }
}
</script>

<style scoped>
:deep(.el-table),
:deep(.el-table__inner-wrapper),
:deep(.el-table__header-wrapper),
:deep(.el-table__body-wrapper),
:deep(.el-table__empty-block),
:deep(.el-table__empty-text),
:deep(.el-table__header),
:deep(.el-table__body),
:deep(.el-table tr),
:deep(.el-table th.el-table__cell),
:deep(.el-table td.el-table__cell) {
  background: transparent !important;
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-row-hover-bg-color: transparent;
  --el-table-header-bg-color: transparent;
  --el-table-border-color: rgba(91, 130, 202, 0.24);
}

:deep(.el-table::before),
:deep(.el-table__inner-wrapper::before) {
  display: none !important;
}

:deep(.el-table__empty-text),
:deep(.el-table th.el-table__cell .cell),
:deep(.el-table td.el-table__cell .cell),
:deep(.el-table .cell) {
  color: #d7e7ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-weight: 300 !important;
}

:deep(.el-table th.el-table__cell),
:deep(.el-table td.el-table__cell) {
  border-bottom-color: rgba(91, 130, 202, 0.2) !important;
}
</style>

